import { render, staticRenderFns } from "./SendToFactory.vue?vue&type=template&id=1a30df89"
import script from "./SendToFactory.vue?vue&type=script&lang=js"
export * from "./SendToFactory.vue?vue&type=script&lang=js"
import style0 from "./SendToFactory.vue?vue&type=style&index=0&id=1a30df89&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports